module.exports = __webpack_public_path__ + "static/img/materialdesignicons-webfont.68e728e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.svg?v=2.7.94
// module id = D7+x
// module chunks = 3